import React from 'react';
import { Card, Typography, Collapse, Space, Tag } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

const Help: React.FC = () => {
  return (
    <div>
      <Title level={2}>
        <QuestionCircleOutlined style={{ marginRight: 8 }} />
        Admin Portal Help & Documentation
      </Title>
      
      <Card style={{ marginBottom: 16 }}>
        <Title level={4}>Getting Started</Title>
        <Paragraph>
          Welcome to the Gaming Platform Admin Portal. This help guide will walk you through the main features and how to use them.
        </Paragraph>
      </Card>

      <Collapse defaultActiveKey={['games', 'categories', 'tags']} ghost>
        <Panel header="Managing Games" key="games">
          <Title level={5}>Adding a New Game</Title>
          <Paragraph>
            1. Navigate to the <Text strong>Games</Text> section from the sidebar.
            <br />2. Click the <Text strong>Add Game</Text> button.
            <br />3. Fill in the game details including name, description, and upload the game files.
            <br />4. Assign categories and tags as needed.
            <br />5. Click <Text strong>Save</Text> to add the game.
          </Paragraph>
          
          <Title level={5} style={{ marginTop: 16 }}>Importing Games in Bulk</Title>
          <Paragraph>
            1. Go to the <Text strong>Import</Text> section.
            <br />2. Prepare a CSV or JSON file with game data.
            <br />3. Upload the file using the import tool.
            <br />4. Map the fields and complete the import process.
          </Paragraph>
        </Panel>

        <Panel header="Managing Categories" key="categories">
          <Title level={5}>Creating a New Category</Title>
          <Paragraph>
            1. Go to the <Text strong>Categories</Text> section.
            <br />2. Click <Text strong>Add Category</Text>.
            <br />3. Enter the category name, slug, and upload an image.
            <br />4. Set the display order and visibility options.
            <br />5. Click <Text strong>Save</Text>.
          </Paragraph>
          
          <Title level={5} style={{ marginTop: 16 }}>Importing Categories</Title>
          <Paragraph>
            You can import multiple categories using the <Text strong>Import</Text> section.
            Ensure your import file includes all required fields: <Tag>name</Tag>, <Tag>slug</Tag>, and <Tag>image</Tag>.
          </Paragraph>
        </Panel>

        <Panel header="Managing Tags" key="tags">
          <Title level={5}>Creating a New Tag</Title>
          <Paragraph>
            1. Navigate to the <Text strong>Tags</Text> section.
            <br />2. Click <Text strong>Add Tag</Text>.
            <br />3. Enter the tag name and slug.
            <br />4. Add an optional description.
            <br />5. Click <Text strong>Save</Text>.
          </Paragraph>
          
          <Title level={5} style={{ marginTop: 16 }}>Tag Management Tips</Title>
          <Paragraph>
            - Tags help users find related games.
            <br />- Use descriptive names that users might search for.
            <br />- Consider creating tags for game genres, features, and themes.
          </Paragraph>
        </Panel>

        <Panel header="User Management" key="users">
          <Title level={5}>Managing User Accounts</Title>
          <Paragraph>
            - View all users in the <Text strong>Users</Text> section.
            <br />- Click on a user to edit their details or reset their password.
            <br />- Use the search and filter options to find specific users.
          </Paragraph>
        </Panel>
      </Collapse>

      <Card style={{ marginTop: 24 }}>
        <Title level={4}>Need More Help?</Title>
        <Paragraph>
          If you can't find what you're looking for or need assistance, please contact the platform administrator.
        </Paragraph>
      </Card>
    </div>
  );
};

export default Help;
